export default __webpack_public_path__ + "static/image-for-families-lg-d9964596547bd6d1235502e8739b9853.png";